export const TEMPLATES = [
  { key: "refill", label: "Refill reminder", text: (c) => `Hi ${first(c)}, your ${c.refill?.product || "medicine"} should be running low soon. Shall I send your next pack?` },
  { key: "tracking", label: "Tracking update", text: (c, link) => `Hi ${first(c)}, your parcel is on its way. Track it here: ${link || "<tracking link>"}` },
  { key: "reorder", label: "Reorder offer", text: (c) => `Hi ${first(c)}, would you like the same order as last time? I can ship it this week.` },
  { key: "hello", label: "Check-in", text: (c) => `Hi ${first(c)}, just checking everything arrived fine and you're happy with it.` },
];

const first = (c) => String(c.name || "").split(" ")[0];

export const inr = (n) => `₹${Math.round(Number(n || 0)).toLocaleString("en-IN")}`;

export const fdate = (iso) => {
  if (!iso) return "—";
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const STATUS = {
  pending: ["Received", "bg-slate-100 text-slate-600"], in_process: ["In process", "bg-sky-100 text-sky-700"],
  completed: ["Completed", "bg-emerald-100 text-emerald-700"], cancelled: ["Cancelled", "bg-rose-100 text-rose-700"],
};

export const shareUrl = (token) => `${window.location.origin}/t/${token}`;
